export default __webpack_public_path__ + "static/media/ag-dropdown.48257d7a.webp";